// AuthContext.js
import React, { createContext, useState, useEffect, useContext, useCallback } from 'react'; // useCallback যোগ করা হয়েছে
import { v4 as uuidv4 } from 'uuid';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem('authToken'));
  const [isAuthenticated, setIsAuthenticated] = useState(!!authToken);
  const [clientId, setClientId] = useState(localStorage.getItem('client_id'));
  const [userInfo, setUserInfo] = useState(null); // userInfo স্টেট যোগ করা হয়েছে

  // clientId ইনিশিয়ালাইজেশন
  useEffect(() => {
    let currentClientId = localStorage.getItem('client_id');
    if (!currentClientId) {
      currentClientId = uuidv4();
      localStorage.setItem('client_id', currentClientId);
      setClientId(currentClientId);
    } else if (!clientId) {
      setClientId(currentClientId);
    }
  }, [clientId]);

  // authToken এবং isAuthenticated আপডেট
  useEffect(() => {
    localStorage.setItem('authToken', authToken || '');
    setIsAuthenticated(!!authToken);
  }, [authToken]);

  // userInfo লোড করুন যখন কম্পোনেন্ট মাউন্ট হয়
  useEffect(() => {
    const storedUserInfo = localStorage.getItem('userInfo');
    if (storedUserInfo) {
      try {
        setUserInfo(JSON.parse(storedUserInfo));
      } catch (e) {
        console.error("Failed to parse userInfo from localStorage", e);
        setUserInfo(null);
      }
    }
  }, []); // শুধু একবার রান হবে

  // লগইন ফাংশন, যা এখন userDetails ও গ্রহণ করে
  const login = useCallback((token, userDetails = null) => {
    setAuthToken(token);
    localStorage.setItem('authToken', token); // নিশ্চিত করুন যে এটি লোকাল স্টোরেজে সেভ হয়
    setIsAuthenticated(true);
    if (userDetails) {
      localStorage.setItem('userInfo', JSON.stringify(userDetails));
      setUserInfo(userDetails);
    }
  }, []);

  // userInfo সংরক্ষণ করার ফাংশন (লগইন বা রেজিস্ট্রেশনের পর)
  const storeUserInfo = useCallback((userDetails) => {
    localStorage.setItem('userInfo', JSON.stringify(userDetails));
    setUserInfo(userDetails);
  }, []);

  // লগআউট ফাংশন
  const logout = useCallback(() => {
    setAuthToken(null);
    localStorage.removeItem('authToken');
    setIsAuthenticated(false);
    localStorage.removeItem('userInfo'); // userInfo ও সরিয়ে ফেলুন
    setUserInfo(null);
    // Optionally clear client_id on logout if you want a new one for a new session
    // localStorage.removeItem('client_id');
    // setClientId(null);
  }, []);

  // API কল করার জন্য হেডার তৈরি করার ফাংশন
  const getAuthHeaders = useCallback(() => {
    const headers = {
      'Content-Type': 'application/json',
    };
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
    if (clientId) {
      headers['X-Client-ID'] = clientId;
    }
    return headers;
  }, [authToken, clientId]);

  return (
    <AuthContext.Provider value={{ authToken, isAuthenticated, userInfo, login, logout, getAuthHeaders, clientId, storeUserInfo }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};